import * as React from "react";
import { forwardRef } from "react";
const SvgClock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 18.75a8.747 8.747 0 0 1-8.084-5.401A8.751 8.751 0 0 1 13.35 1.916 8.755 8.755 0 0 1 18.75 10 8.753 8.753 0 0 1 10 18.75ZM10 2.5a7.504 7.504 0 0 0-6.93 4.63A7.5 7.5 0 1 0 10 2.5Z", fill: "#1F273B" }), /* @__PURE__ */ React.createElement("path", { d: "m12.869 13.75-3.494-3.494V4.375h1.25v5.363l3.125 3.13-.881.882Z", fill: "#1F273B" }));
const ForwardRef = forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
